




































































































import {Component, Prop, Ref, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service"
import PodsetnikVozilaDialog from "@/views/Podsetnici/PodsetnikVozilaDialog.vue";
import {formatDate} from "@/utils/formatters";
import moment from "moment";
import {PodsetnikVozila} from "@/services/BackendProxies";
import storage from "@/services/local-storage.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import CalendarComponent2 from "@/components/CalendarComponent2.vue";
import * as _ from 'lodash';
import {sortByDate} from "@/utils/functions";

declare const $: any;

@Component({components: {'mf-dodaj-podsetnik': PodsetnikVozilaDialog, 'mf-calendar': CalendarComponent2}})
export default class PregledPodsetnikaVozila extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @Prop({default: undefined}) voziloId!: number;

    podsetniciVozila = [];
    columns = [];
    dialogVisible = false;
    podsetnikRow = PodsetnikVozila.fromJS({ukljucen: true});
    isBusy = false;
    view: any = '';

    tableOptions = {
        rowStyle: this.rowStyle,
        detailView: true,
        detailFormatter: this.renderDetails,
        onClickRow: row => this.onClickRow(row),
        pagination: true,
        search: true
    };

    selected = 'datumskiPrikaz';
    radioOptions = [];

    prikaziOptions = [25,50,75,100,200];
    prikazSelected: any = 25;
    @Ref('calendar') readonly calendar!: CalendarComponent2;

    get filteredData() {
        return this.podsetniciVozila.filter(x => this.selected === 'datumskiPrikaz' ? x.datum : !x.datum);
    }

    async created() {
        this.isBusy = true;

        this.prikazSelected = storage.get('prikazSelectedStorage') ? storage.get('prikazSelectedStorage') : this.prikazSelected;

        this.radioOptions = [
            {text: this.$i18n.t('datumskiPrikaz'), value: 'datumskiPrikaz'},
            {text: this.$i18n.t('prikazSaKilometrazom'), value: 'prikazSaKilometrazom'}
        ];

        try {
            if (!this.voziloId) {
                this.podsetniciVozila = await this.loadData(() => dataProxy.vratiPodsetnikeVozila())();
            } else {
                this.podsetniciVozila = await this.loadData(() => dataProxy.vratiPodsetnikePoVozilu(this.voziloId))();
            }
            this.columns = [
                {field: 'vozilo', title: this.$i18n.t('vozilo'), width: 170},
                {field: 'datum', title: this.$i18n.t('datum'), width: 130,
                    formatter: value => value ? formatDate(value) : '', sortable: true, sorter: (f1, f2) => sortByDate(f1, f2), visible: this.selected === 'datumskiPrikaz'},
                {field: 'stanjeKilometraze', title: this.$i18n.t('stanjeKilometraze'), width: 120,
                    formatter: value => value ? value + this.$i18n.t('km') : '', sortable: true, visible: this.selected === 'prikazSaKilometrazom'},
                {field: 'upozoriPre', title: this.$i18n.t('upozoriPre'), width: 130, formatter: this.upozoriPreFormatter, sortable: true},
                {field: 'razlika', title: this.$i18n.t('razlika'), width: 110, formatter: (value, row) => this.razlikaFormatter(value, row), sortable: true},
                {field: 'opis', title: this.$i18n.t('opis'), width: 200, sortable: true},
                {field: 'ukljucen', title: this.$i18n.t('ukljucen'), width: 100,
                    formatter: value => value ? this.$i18n.t('da') : this.$i18n.t('ne'), sortable: true},
                {field: 'id', cellStyle: this.cellStyle, width: 30,
                    formatter: (value) => `<i class="fa fa-trash text-danger btn-delete" data-id="${value}"></i>`}
            ];
            this.isBusy = false;
        } catch (err) {
            this.isBusy = false;
        }

        if (storage.get('podsetnikVozilaView') !== null) {
            if (storage.get('podsetnikVozilaView') === 'CALENDAR_VIEW') {
                setTimeout(() => this.view = storage.get('podsetnikVozilaView'), 1000);
            } else {
                this.view = storage.get('podsetnikVozilaView');
            }
        } else {
            this.view = 'TABLE_VIEW';
        }


    }

    async eventsLoader() {
        let podsetnici;
        if (this.voziloId) {
            podsetnici = await dataProxy.vratiPodsetnikePoVozilu(this.voziloId);
        } else {
            podsetnici = await dataProxy.vratiPodsetnikeVozila();
        }
        return podsetnici.map(podsetnik => ({
            title: this.voziloId ? podsetnik.opis : `${podsetnik.vozilo} \n ${podsetnik.opis}`,
            start: podsetnik.datum,
            allDay: true,
            extendedProps: podsetnik
        }));
    }

    eventStyler(event) {
        event.el.style.color = 'white';
        event.el.style.borderColor = 'white';

        if (!event.event.extendedProps.ukljucen) {
            event.el.style.borderColor = '#E5E7E9';
            event.el.style.backgroundColor = '#E5E7E9';
            return;
        }

        let rowDate = moment(event.event.start);
        let todaysDate = moment();
        let result = rowDate.diff(todaysDate, 'days');
        if (todaysDate.isAfter(rowDate)) {
            event.el.style.backgroundColor = '#f7531f';
            event.el.style.borderColor = '#f7531f';
        } else if (result < event.event.extendedProps.upozoriPre) {
            event.el.style.backgroundColor = '#ff9800';
            event.el.style.borderColor = '#ff9800';
        } else {
            event.el.style.borderColor = '#348cd4';
        }
    }

    eventClicked(podsetnik: PodsetnikVozila) {
        this.podsetnikRow = PodsetnikVozila.fromJS(podsetnik);
        this.dialogVisible = true;
    }

    dateClicked(date: Date) {
        this.podsetnikRow = PodsetnikVozila.fromJS({
            ukljucen: true,
            datum: date,
            voziloId: this.voziloId,
            primaoci: []
        });
        this.dialogVisible = true;
    }

    upozoriPreFormatter(value, row) {
        if (row.datum) {
            return `${row.upozoriPre} ${row.upozoriPre > 1 ? this.$i18n.t('danaUpozoriPre') : this.$i18n.t('danUpozoriPre')} `
        }
        if (row.stanjeKilometraze) {
            return `${row.upozoriPre} ${this.$i18n.t('km')}`
        }
    }

    rowStyle(row, index) {
        if (!row.ukljucen) {
            return {'css' : {'color' : '#b3b4b6'}}
        }
        let rowDate = moment(row.datum);
        let todaysDate = moment();
        let result = rowDate.diff(todaysDate, 'days');
        //TODO ZA KILOMETRAZU
        if (todaysDate.isAfter(rowDate)) {
            return {'css' : {'color' : '#f7531f'}}
        } else if (result < row.upozoriPre) {
            return {'css' : {'color' : '#ff9800'}}
        } else {
            return {'css' : {'color' : '#348cd4'}}
        }
    }

    timeLineCircleStyle(p) {
        if (!p.ukljucen) {
            return 'timeline-icon bg-secondary';
        }
        if (p.datum) {
            let rowDate = moment(p.datum);
            let todaysDate = moment();
            let result = rowDate.diff(todaysDate, 'days');
            if (todaysDate.isAfter(rowDate)) {
                return 'timeline-icon bg-danger';
            } else if (result < p.upozoriPre) {
                return 'timeline-icon bg-warning'
            } else {
                return 'timeline-icon bg-primary'
            }
        } else if (p.stanjeKilometraze) {
            if (p.razlika > p.upozoriPre) return 'timeline-icon bg-primary';
            return p.razlika < 0 ? 'timeline-icon bg-danger' : 'timeline-icon bg-warning';
        }
    }

    timeLineTextStyle(p) {
        if (!p.ukljucen) {
            return 'mt-0 text-secondary';
        }
        if (p.datum) {
            let rowDate = moment(p.datum);
            let todaysDate = moment();
            let result = rowDate.diff(todaysDate, 'days');
            if (todaysDate.isAfter(rowDate)) {
                return 'mt-0 text-danger';
            } else if (result < p.upozoriPre) {
                return 'mt-0 text-warning'
            } else {
                return 'mt-0 text-primary'
            }
        } else if (p.stanjeKilometraze) {
            if (p.razlika > p.upozoriPre) return 'mt-0 text-primary';
            return p.razlika < 0 ? 'mt-0 text-danger' : 'mt-0 text-warning';
        }
    }

    //TODO: TimeLineStyle za Kilometrazu kad se uveze

    cellStyle(value, row, index) {
        return {
            classes: 'text-nowrap',
            css: {"color": "white"}
        };
    }

    sortTimeLine(row) {
        let rowDate = moment(row.datum);
        let todaysDate = moment();
        let result = rowDate.diff(todaysDate, 'days');
    }

    async updateTable() {
        if (!this.voziloId) {
            this.podsetniciVozila = await this.loadData(() => dataProxy.vratiPodsetnikeVozila())();
        } else {
            this.podsetniciVozila = await this.loadData(() => dataProxy.vratiPodsetnikePoVozilu(this.voziloId))();

        }
        if (this.calendar) {
            this.calendar.reload();
        }
    }

    razlikaFormatter(value, row) {
        if (row.datum) {
            return `${value} ${this.$i18n.t('dana')}`
        }
        if (row.stanjeKilometraze) {
            return `${value} km`
        }
    }

    onClickRow(row) {
        this.dialogVisible = true;
        this.podsetnikRow = {...row};
    }

    onClickRowTimeLine(row) {
        this.dialogVisible = true;
        this.podsetnikRow = {...row};
    }

    renderDetails(ix, podsetnikVozila: PodsetnikVozila, element) {
        const detailsTableId = `detailsTable_${ix}`;
        const $detailsTable = $(`<table class="${detailsTableId}"></table>`).bootstrapTable({
            columns: [
                {field: 'display', title: this.$i18n.t('primaoc'), formatter: value => value ? value : ''},
                {field: 'ukljucen', title: this.$i18n.t('ukljucen'), width: 100,
                    formatter: value => value ? this.$i18n.t('da') : this.$i18n.t('ne')}
            ],
            data: podsetnikVozila.primaoci
        });
        $detailsTable.appendTo(element);
    }

    setView(view: string) {
        this.view = view;
        storage.add('podsetnikVozilaView', this.view);
        if (this.view === 'TABLE_VIEW') {
            this.updateTable();
        }
    }

    @Watch('prikazSelected') onPrikazSelectedChange(value) {
        storage.add('prikazSelectedStorage', value);
    }

    onPostBody() {
        $("i.btn-delete").on('click', async e => {
            const id = $(e.currentTarget).data('id');
            if (id) {
                e.stopPropagation();
                const da = await this.confirmationNeeded('da li zelite da obrisete podsetnik');
                if (da) {
                    this.podsetniciVozila = this.podsetniciVozila.filter(x => x.id != id);
                    await this.deleteData(() => dataProxy.obrisiPodsetnik(id))();
                }
            }
        })
    }

    get datumskiPodsetniciZaTimeline() {
        return _.take(_.sortBy(this.podsetniciVozila.filter(x => x.datum), 'razlika'), this.prikazSelected);
    }

    get kilometarskiPodsetniciZaTimeline() {
        return _.take(_.sortBy(this.podsetniciVozila.filter(x => x.stanjeKilometraze), 'razlika'), this.prikazSelected);
    }

    @Watch('selected')
    onSelectedChanged() {
        const table: any = this.$refs.table;
        if (this.selected === 'datumskiPrikaz') {
            table.showColumn('datum');
            table.hideColumn('stanjeKilometraze');
        } else {
            table.hideColumn('datum');
            table.showColumn('stanjeKilometraze');
        }
    }

}
